import { useEffect } from 'react'
import { checkTimeOffset } from '$logic/client-device/time-offset.service'
import { MINUTE_MS, SECOND_MS } from '$func/time'

export function useDetectSystemTimeChange(
  intervalMS = 5 * SECOND_MS,
  toleranceMS = MINUTE_MS,
) {
  useEffect(() => {
    let oldTime = Date.now()

    const interval = setInterval(() => {
      const newTime = Date.now()
      const timeDiff = Math.abs(newTime - oldTime - intervalMS)
      oldTime = Date.now()

      if (timeDiff > toleranceMS) checkTimeOffset()
    }, intervalMS)

    return () => {
      clearInterval(interval)
    }
  }, [])
}
